import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import CKEditor from "react-ckeditor-component";
import Multiselect from "multiselect-react-dropdown";

import {
  getSubCategoriesList,
  getCategories,
  getStateList
} from "../../redux/actions/indexActions";
import { toast } from "react-toastify";

const EditPlace = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    sub_sub_category_id: "",
    state_id: "",
    city_id: 0,
    town_id: 0,
    place_name: "",
    latitude: 0,
    longitude: 0,
    map_url: "",
    amount: 0,
    type: "Free",
    description: "",
    short_description: "",
    featured: 0,
    status: 1,
    booking_status: 1,
    place_image: "",
    courseCategory: [],
    courseSubCategory: [],
    courseSubSubCategory: [],
    course_type: "",
    course_category_id: "",
    course_sub_category_id: "",
    courseSubCategoryId: "",
    courseSubSubCategoryId: "",
    indian_fee: "",
    foreigner_fee: "",
    foreigner_student_fee: "",
    indian_student_fee: "",
    schedule_timging: {},
    extra_timging_info: "",
    visitors_information: "",
    things_to_see: "",
    how_to_reach: "",
    food_type: "",

  });
  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [text, setText] = useState([]);
  const [extraTimgingInfo, setExtraTimgingInfo] = useState([]);
  const [scheduledTimes, setScheduledTimes] = useState({});
  const [visitorInfo, setVisitorInfo] = useState([]);
  const [howToReach, setHowToReach] = useState([]);
  const [thingsToSee, setThingsToSee] = useState([]);
  const [courseCategory, setCourseCategory] = useState([]);
  const [courseCategoryOption, setCourseCategoryOption] = useState([]);
  const [courseSubCategory, setCourseSubCategory] = useState([]);
  const [courseSubCategoryOption, setCourseSubCategoryOption] = useState([]);
  const [courseSubSubCategory, setCourseSubSubCategory] = useState([]);
  const [towns, setTowns] = useState([]);
  const [courseSubSubCategoryOption, setCourseSubSubCategoryOption] = useState([]);
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList, subCategoriesList, stateLists }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "place_image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "booking_status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: 0 });
    }

    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }
  const handleExtraTimgingTnfo = (e) => {
    const timingInfo = e.editor.getData();
    setExtraTimgingInfo(timingInfo);
  }
  const handleVisitorsInfo = (e) => {
    const visitorInfo = e.editor.getData();
    setVisitorInfo(visitorInfo);
  }
  const handleThingsToSee = (e) => {
    const thingsToSee = e.editor.getData();
    setThingsToSee(thingsToSee);
  }
  const handlehowToReach = (e) => {
    const howToReach = e.editor.getData();
    setHowToReach(howToReach);
  }

  const handleScheduledTimes = (e) => {
    
  }

  useEffect(() => {
    dispatch(getStateList(auth.token));
    dispatch(getCategories(auth.token));
  }, [auth]);
  useEffect(() => {

    axios.get(`/api/admin/v1/categories`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    }).then((res) => {
      // setCourseCategory([])
      setCourseCategoryOption(
        res.data.categories.map((item) => ({ name: item.name, id: item.id }))
      );
    })
      .catch((err) => console.error(err));

  }, []);

  const handlePaymentTypeChange = (e) => {
    setFormData({
      ...formData,
      type: e.target.value
    })
  };
  useEffect(() => {
    if (formData?.category_id) {
      axios(`/api/admin/v1/get-subcategory-by-category/${formData?.category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubCategoryList(data?.subCategoriesbyCategory);
        }).catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [formData?.category_id]);

  useEffect(() => {
    if (formData?.sub_category_id) {
      axios(`/api/admin/v1/get-subsubcategory-by-subcategory/${formData?.sub_category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubSubCategoryList(data?.subSubCategoriesbySubCategory);
        }).catch((err) => console.error(err));
    } else {
      setSubSubCategoryList([]);
    }
  }, [formData?.sub_category_id]);

  const handleCourseCategoryChange = (val) => {
    console.log(val, "val");
    if (val.length) {
      axios.get(
        `/api/admin/v1/sub-category-list?id=${val
          .map((it) => it.id)
          .join(",")}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      ).then(({ data }) => {
        setCourseSubCategory((prev) =>
          prev?.filter((item) => val.find((it) => it.id === item.id))
        );
        setCourseSubCategoryOption(
          data.data.map((item) => {
            return {
              name: item.title_english,
              id: item.id,
              category_id: item.category_id,
            };
          })
        );
      })
        .catch((err) => console.log(err));
    } else {
      setCourseSubCategory([]);
      setCourseSubCategoryOption([]);
    }
  };

  const handleCourseSubCategoryChange = (val) => {
    if (val.length) {
      axios.get(
        `/api/admin/v1/sub-sub-category-list?category_id=${val
          .map((item) => item.category_id)
          .join(",")}&sub_category_id=${val.map((it) => it.id).join(",")}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      ).then(({ data }) =>
        setCourseSubSubCategoryOption(
          data.data.map((item) => {
            return {
              name: item.title_english,
              id: item.id,
              category_id: item.category_id,
              sub_category_id: item.sub_category_id,
            };
          })
        )
      ).catch((err) => console.log(err));
    } else {
      setCourseSubSubCategory([]);
      setCourseSubSubCategoryOption([]);
    }
  };


  useEffect(() => {
    if (formData.state_id) {
      setFormData((prev) => ({ ...prev }));
      axios(`/api/admin/v1/get-city/${formData.state_id}`)
        .then(({ data }) => {
          setCities(data?.data);
        }).catch((err) => console.error(err));
    } else {
      setCities([]);
    }
  }, [formData.state_id]);

  useEffect(() => {
    if (formData.state_id && formData.city_id) {
      //setFormData((prev) => ({ ...prev, town_id: "" }));
      axios(`/api/admin/v1/get-town/${formData.state_id}/${formData.city_id}`)
        .then(({ data }) => {
          console.log(data?.data, 'date11111');
          setTowns(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setTowns([]);
    }
  }, [formData?.state_id, formData?.city_id]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');

  const options = [
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' },
  ];

  const timeSlots = [
    { value: '9AM-12PM', label: '9 AM - 12 PM' },
    { value: '12PM-3PM', label: '12 PM - 3 PM' },
    { value: '3PM-6PM', label: '3 PM - 6 PM' },
    { value: '6PM-9PM', label: '6 PM - 9 PM' },
    { value: 'Closed', label: 'Closed' },
  ];
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
    setSelectedTime(scheduledTimes[event.target.value] || '');
  };


  const handleTimeChange = (event) => {
    const time = event.target.value;

    if (selectedDate && time) {
      setScheduledTimes((prev) => ({
        ...prev,
        [selectedDate]: time,
      }));
      setSelectedDate('');
      setSelectedTime('');
    }
  };
  const handleDeleteTimeSlot = (event, day) => {
    event.preventDefault();
    setScheduledTimes((prev) => {
      const updated = { ...prev };
      delete updated[day];
      return updated;
    });
  };


  const handleSubmit = () => {
    const form = new FormData();

    form.append('category_id', formData.category_id)
    form.append('sub_category_id', formData.sub_category_id)
    form.append('sub_sub_category_id', formData.sub_sub_category_id)
    form.append('state_id', formData.state_id)
    form.append('city_id', formData.city_id)
    form.append('town_id', formData.town_id)
    form.append('place_name', formData.place_name)
    form.append('latitude', formData.latitude)
    form.append('longitude', formData.longitude)
    form.append('map_url', formData.map_url)
    form.append('type', formData.type)
    form.append('amount', formData.amount)
    form.append('short_description', formData.short_description)
    form.append('place_image', formData.place_image)
    form.append('description', text)
    form.append('extra_timging_info', extraTimgingInfo)
    form.append('visitors_information', visitorInfo)
    form.append('how_to_reach', howToReach)
    form.append('things_to_see', thingsToSee)
    form.append('schedule_timging', JSON.stringify(scheduledTimes))
    form.append("open_time", formData.open_time)
    form.append("close_time", formData.close_time)
    form.append("featured", formData.featured)
    form.append("status", formData.status)
    form.append("booking_status", formData.booking_status)
    form.append("indian_fee", formData.indian_fee)
    form.append("foreigner_fee", formData.foreigner_fee)
    form.append("foreigner_student_fee", formData.foreigner_student_fee)
    form.append("indian_student_fee", formData.indian_student_fee)
    form.append("food_type", formData.food_type)
    courseCategory
      ? courseCategory.map((s, i) => {
        form.append(`courseCategory[${i}][id]`, s.id);
        form.append(`courseCategory[${i}][name]`, s.name);
      }) : form.append("courseCategory", []);
    courseSubCategory
      ? courseSubCategory.map((s, i) => {
        form.append(`courseSubCategory[${i}][id]`, s.id);
        form.append(`courseSubCategory[${i}][name]`, s.name);
        form.append(`courseSubCategory[${i}][category_id]`, s.category_id);
      }) : form.append("courseSubCategory", []);
    courseSubSubCategory
      ? courseSubSubCategory.map((s, i) => {
        form.append(`courseSubSubCategory[${i}][id]`, s.id);
        form.append(`courseSubSubCategory[${i}][name]`, s.name);
        form.append(`courseSubSubCategory[${i}][category_id]`, s.category_id);
        form.append(
          `courseSubSubCategory[${i}][sub_category_id]`,
          s.sub_category_id
        );
      }) : form.append("courseSubSubCategory", []);

    console.log("schedule timing from submit", scheduledTimes);
    axios.put(`/api/admin/v1/update-place/${id}`, form, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    }).then((res) => {
      toast.success(res.data?.message);
      navigate(-1);
    }).catch((err) => {
      toast.error(err.response.data);
      setErrors(err.response.data);
    });
  };
  useEffect(() => {
    axios(`/api/admin/v1/edit-place/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        const scheduleString = res.data?.places?.schedule_timing;
        const schedule = scheduleString ? JSON.parse(scheduleString) : {};
        const scheduleArray = Object.entries(schedule);

        setText(res.data?.places?.description);
        setExtraTimgingInfo(res.data?.places?.extra_timging_info);
        setVisitorInfo(res.data?.places?.visitors_information);
        setHowToReach(res.data?.places?.how_to_reach);
        setThingsToSee(res.data?.places?.things_to_see);
        setScheduledTimes(scheduleArray ? scheduleArray : []);
        setFormData({
          category_id: res.data?.places?.category_id,
          sub_category_id: res.data?.places?.sub_category_id,
          sub_sub_category_id: res.data?.places?.sub_sub_category_id,
          state_id: res.data?.places?.state_id,
          city_id: res.data?.places?.city_id,
          town_id: res.data?.places?.town_id,
          place_name: res.data?.places?.place_name,
          latitude: res.data?.places?.latitude,
          longitude: res.data?.places?.longitude,
          map_url: res.data?.places?.map_url,
          type: res.data?.places?.type,
          amount: res.data?.places?.amount,
          short_description: res.data?.places?.short_description,
          open_time: res.data?.places?.open_time,
          close_time: res.data?.places?.close_time,
          featured: res.data?.places?.featured,
          status: res.data?.places?.status,
          booking_status: res.data?.places?.booking_status,
          indian_fee: res.data?.places?.indian_fee,
          foreigner_fee: res.data?.places?.foreigner_fee,
          foreigner_student_fee: res.data?.places?.foreigner_student_fee,
          indian_student_fee: res.data?.places?.indian_student_fee,
        });
        setCourseCategory(
          res.data?.places?.place_category_ids?.map((item) => ({
            name: item?.category?.name,
            id: item?.category?.id,
          })) || []
        );

        setCourseSubCategory(
          res.data?.places?.place_sub_category_ids?.map((sc) => ({
            name: sc?.sub_category?.title_english,
            id: sc?.sub_category?.id,
            category_id: sc?.sub_category?.category_id,
          })) || []
        );

        setCourseSubSubCategory(
          res.data?.places?.place_sub_sub_category_ids?.map((sc) => ({
            name: sc?.sub_sub_category?.title_english,
            id: sc?.sub_sub_category?.id,
            category_id: sc?.sub_sub_category?.category_id,
            sub_category_id: sc?.sub_sub_category?.sub_category_id,
          })) || []
        );

      })
      .catch((err) => console.log(err));
  }, [auth]);

  console.log("courseSubCategory", courseSubCategory);


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-10">
          <h4 className="text-white">Edit Place</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label> Category</Label>
              <Multiselect
                className="text-black"
                options={courseCategoryOption}
                displayValue="name"
                selectedValues={courseCategory}
                onSelect={(val) => {
                  setCourseCategory([...val]);
                  handleCourseCategoryChange(val);
                }}
                onRemove={(val) => {
                  setCourseCategory([...val]);
                  handleCourseCategoryChange(val);
                }}
                labelledBy="Select"
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label> Sub Category</Label>
              <Multiselect
                className="text-black"
                options={courseSubCategoryOption}
                displayValue="name"
                selectedValues={courseSubCategory}
                onSelect={(val) => {
                  setCourseSubCategory([...val]);
                  handleCourseSubCategoryChange(val);
                }}
                onRemove={(val) => {
                  setCourseSubCategory([...val]);
                  handleCourseSubCategoryChange(val);
                }}
                labelledBy="Select"
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label> Sub Sub Category</Label>
              <Multiselect
                className="text-black"
                options={courseSubSubCategoryOption}
                selectedValues={courseSubSubCategory}
                displayValue="name"
                onSelect={(val) => {
                  setCourseSubSubCategory(val);
                }}
                onRemove={(val) => setCourseSubSubCategory([...val])}
                labelledBy="Select"
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.state_id}
                type="select"
                name="state_id"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                {stateLists?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.state_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.state_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>City </Label>
              <Input
                value={formData?.city_id}
                type="select"
                name="city_id"
                onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}
              >
                <option value="">Select</option>
                {cities?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.city_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.city_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Town</Label>
              <Input
                invalid={Boolean(errors?.town_id)}
                value={formData?.town_id}
                type="select"
                name="town_id"
                onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}
              >
                <option value="">Select</option>
                {towns?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.town_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.town_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.place_name)}
                value={formData?.place_name}
                name="place_name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.place_name} </span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Featured</Label>
              <Input value={formData?.featured} name="featured" onChange={inputHandler} />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Image </Label>
              <Input type="file" invalid={Boolean(errors?.place_image)} name="place_image"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.place_image}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Description <span className="text-danger fs-4">*</span></Label>
              <Input
                name="short_description"
                value={formData?.short_description}
                type="textarea"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.short_description}</span>
            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Full Description</Label>
              <CKEditor
                content={text}
                events={{
                  "change": handleText
                }}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Latitude</Label>
              <Input invalid={Boolean(errors?.latitude)} value={formData?.latitude} name="latitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.latitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Longitude </Label>
              <Input invalid={Boolean(errors?.longitude)} value={formData?.longitude} name="longitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.longitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Map Url</Label>
              <Input invalid={Boolean(errors?.map_url)} value={formData?.map_url} name="map_url" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.map_url} </span>
            </FormGroup>
          </div>
          {Array.isArray(courseSubCategory) &&
            courseSubCategory.some(item => item.id === 50) && (
              <div className="col-md-4 offset-md-1">
                <FormGroup>
                  <Label>Food Type <span className="text-danger fs-4">*</span></Label>
                  <Input
                    type="select"
                    invalid={Boolean(errors?.food_type)}
                    value={formData?.food_type || ""}
                    name="food_type"
                    onChange={inputHandler}
                  >
                    <option value="">Select Food Type</option>
                    <option value="veg">Veg</option>
                    <option value="nonveg">Non-Veg</option>
                  </Input>
                  <span className="d-block text-danger">{errors?.food_type}</span>
                </FormGroup>
              </div>
            )}
        </div>
        <div className="row">
          <div className="col-md-2">
            <FormGroup switch>
              <Input type="switch" checked={formData?.status} onChange={inputHandler} name="status" />
              <Label check>Post Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-6 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPlace;
